import { BaseBannersClient } from "@core/types";
import { supabaseClient } from "../supabase";
import { convertSupaBannerToBanner } from "./converters";

class BannersClient extends BaseBannersClient {
  async getBanners() {
    const { data: banners } = await supabaseClient.from("banners").select("*").throwOnError();

    return banners?.map(convertSupaBannerToBanner);
  }
}

export default BannersClient;
